export const editorV2ContentHasText = (content?: string): boolean =>
  content?.replaceAll('<p>', '').replaceAll('</p>', '').trim().length > 0;
